'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const SelectionSetTilePrice = renderWithRef('SelectionSetTilePrice', null, (o, t)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-selection-set-tile-price'
        ],
        props: o,
        children: o.children
    }));

export { SelectionSetTilePrice };
